import React from 'react';
import PropTypes from 'prop-types';
import { scrollToTop } from '../../utils/smartutils';

const HourField = ({
  input,
  placeholder,
  time,
  disabled,
  minHour,
  maxHour,
  meta: { touched, error },
  invalidateField,
}) => {
  const between = (value, min, max) => value >= min && value <= max;

  // eslint-disable-next-line no-unused-vars
  const validateInterval = () => {
    const min = parseInt(minHour.replace(':', ''), 10);
    const max = parseInt(maxHour.replace(':', ''), 10);
    const value = parseInt(input.value.replace(':', ''), 10);
    const valid = between(value, min, max);
    if (!valid) {
      if (invalidateField) {
        invalidateField(input.name, minHour, maxHour);
      }
    }
  };

  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above form__input-time">
      <input
        {...input}
        type="time"
        value={input.value || time}
        placeholder={placeholder}
        disabled={disabled}
        min={minHour}
        max={maxHour}
        onChange={(event) => {
          if (event.target.value) {
            input.onChange(event);
          }
        }}
      />
      {touched && error && (
        <span className="form__form-group-error">
          {error}
          {scrollToTop()}
        </span>
      )}
    </div>
  );
};

HourField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  minHour: PropTypes.string,
  maxHour: PropTypes.string,
  time: PropTypes.string,
  invalidateField: PropTypes.func,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

HourField.defaultProps = {
  meta: null,
  disabled: false,
  minHour: '00:00',
  maxHour: '23:59',
  placeholder: '',
  time: '',
  invalidateField: null,
};

export default HourField;
